import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/lib/auth";

export function AuthCallbackPage() {
  const { completeAuthFromCallback } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState<string | null>(null);
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const code = searchParams.get("code");
    const errorParam = searchParams.get("error");
    const errorDesc = searchParams.get("error_description");

    if (errorParam) {
      setError(errorDesc || errorParam);
      return;
    }

    if (!code) {
      setError("No authorization code received");
      return;
    }

    completeAuthFromCallback(code)
      .then(() => navigate("/", { replace: true }))
      .catch((err) => setError(err instanceof Error ? err.message : "Login failed"));
  }, [searchParams, completeAuthFromCallback, navigate]);

  if (error) {
    return (
      <div className="min-h-screen bg-admin-bg flex items-center justify-center p-4">
        <div className="w-full max-w-md text-center space-y-4">
          <div className="rounded-md bg-admin-danger-500/10 border border-admin-danger-500/20 p-4">
            <p className="text-sm text-admin-danger-400">{error}</p>
          </div>
          <button
            className="text-sm text-admin-primary hover:underline"
            onClick={() => navigate("/", { replace: true })}
          >
            Tilbake til innlogging
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-admin-bg flex items-center justify-center p-4">
      <div className="flex flex-col items-center gap-3">
        <Loader2 className="h-6 w-6 animate-spin text-admin-primary" />
        <p className="text-sm text-admin-text-subtle">Logger inn med BankID...</p>
      </div>
    </div>
  );
}
